import { config } from '../../config';
import { isHermesApp, isIOS } from '../../utils/device';

export function getSubscriptionPrice() {
  let price = config.subscription.price;

  if (isHermesApp && isIOS) {
    price = config.subscription.inAppPrice;
  }

  return price;
}
